import { afterNextRender, Component, ElementRef, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DealerRepComponentState } from '../../shared/state-interface';
import { DealerRep } from './dealer-rep.model';

@Component({
    selector: 'app-dealer-rep-component',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule
    ],
    templateUrl: './dealer-rep.component.html',
    styleUrl: './dealer-rep.component.css'
})
export class DealerRepComponent {

    protected dealerRepForm = new FormGroup({
        firstName: new FormControl(""),
        lastName: new FormControl(""),
        email: new FormControl(""),
        phone: new FormControl("")
    });

    private elementRef: ElementRef = inject(ElementRef);

    public constructor() {
        afterNextRender(() => {
            // This LifeCycle hook primarily supports the "Add" Use Case and
            // the browser back button Use Case. The setTimeout is necessary
            // to put these commands at the end of the event queue in attempt
            // to delay their invocation until the DOM is fully updated. Same
            // functions are invoked from the populateFormFromModel function
            // to support the "Update" Use Case.
            setTimeout(() => {
                const ref = this.elementRef.nativeElement.querySelector("input");
                ref?.focus();
                ref?.select();
            }, 0);
        });
    }

    public getState() {
        const state: DealerRepComponentState = {} as DealerRepComponentState;
        state.dealerRepForm = this.dealerRepForm;
        return state;
    }

    public restoreState(state: DealerRepComponentState) {
        this.dealerRepForm = state.dealerRepForm;
    }

    public populateFormFromModel(dealerRep: DealerRep) {
        this.firstNameCtl.setValue(dealerRep.first_name);
        this.lastNameCtl.setValue(dealerRep.last_name);
        this.emailCtl.setValue(dealerRep.email);
        this.phoneCtl.setValue(dealerRep.phone);

        const ref = this.elementRef.nativeElement.querySelector("input");
        ref?.focus();
        ref?.select();
    }

    public createModelFromForm(dealerRep: DealerRep): DealerRep {
        dealerRep.first_name = this.firstNameCtl.value;
        dealerRep.last_name = this.lastNameCtl.value;
        dealerRep.email = this.emailCtl.value;
        dealerRep.phone = this.phoneCtl.value;
        return dealerRep;
    }

    private get lastNameCtl(): FormControl {
        return this.dealerRepForm.controls.lastName;
    }

    private get firstNameCtl(): FormControl {
        return this.dealerRepForm.controls.firstName;
    }

    private get emailCtl(): FormControl {
        return this.dealerRepForm.controls.email;
    }

    private get phoneCtl(): FormControl {
        return this.dealerRepForm.controls.phone;
    }
}